import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    let contentEl = document.getElementById("contents");
    contentEl && (contentEl.scrollTop = 0);
  }, [pathname]);

  return null;
}
